<template>
  <section class="home-section home-mejora mb-3 mb-5">
    <div class="container">
      <div class="section-head mb-4">
        <div class="service-head-bg">
          <img
            src="@/assets/images/service-head-bg-5.jpg"
            alt
            class="img-fluid"
          />
        </div>
        <div class="sec-header">
          <h1 class="sec-title"><span>5.</span>Mejora de <br />Producto</h1>
          <h2 class="sec-subtitle">
            PRODUCTO Mayor calidad y
            <br />mejoramiento en el <br />almacenamiento de <br />mercancía.
          </h2>
          <div class="section-head-action">
            <router-link
              class="btn btn-outline-light rounded-0 font-weight-bold"
              to="/servicios"
              >+ Info</router-link
            >
          </div>
        </div>
      </div>
      <div class="sec-content">
        <div class="row">
          <div class="col-md-4 sec-desc">
            <h2 class="sec-desc-title">Etiquetado / Maquila</h2>
            <h3 class="sec-desc-subtitle">Preparación de producto.</h3>
            <p class="sec-desc-cont">
              Buscando brindarle una amplia gama de servicios y reducir sus
              costos de traslado en su cadena logística hemos logrado con
              personal capacitado, realizar los procesos de maquila y
              preparación que su producto requiera dentro del mismo almacén.
            </p>
          </div>
          <div class="col-md-4 sec-desc">
            <h2 class="sec-desc-title">Trasegado</h2>
            <h3 class="sec-desc-subtitle">Manejo de líquidos</h3>
            <p class="sec-desc-cont">
              Un servicio importante dentro de nuestra cartera de operaciones
              logísticas, es ofrecerles a nuestros clientes el trasiego de
              líquidos de contenedores de mayor capacidad a contenedores de
              menor capacidad. Bajo esta modalidad nuestro personal se encuentra
              ampliamente capacitado en el manejo, vaciado y llenado de fluidos
              para trasegar líquidos de un recipiente a otro.
            </p>
          </div>
          <div class="col-md-4 sec-desc">
            <h2 class="sec-desc-title">Empaquetado</h2>
            <h3 class="sec-desc-subtitle">Conservación de mercancía</h3>
            <p class="sec-desc-cont">
              El empaquetado y sellado de contenedores, cajas o recipientes
              garantizan la permanencia del producto en condiciones óptimas, el
              cual se sustituye en determinado períodos dependiendo del tiempo
              de permanencia dentro de nuestros almacenes.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HomeMejora',
}
</script>

<style lang="scss" scoped>
.home-section {
  .sec-header h2 {
    margin-bottom: 1.5rem;
  }
  .sec-desc-title {
    margin-bottom: 0;
    font-size: 2.7rem;
    line-height: 2.7rem;
  }
  .sec-desc-subtitle {
    font-size: 1.6rem;
    line-height: 1.6rem;
    font-weight: 200;
    margin-bottom: 1.5rem;
  }
}
</style>
